// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"163":"5add6230","323":"034b921e"}[chunkId] + ".chunk.js";
};